<template>
  <div
    class="directory"
    :class="{
      'directory--is-loading': isLoading,
    }"
  >
    <GuildSearch
      class='directory__input'
      :value='inputText'
      @input="$emit('text-input', $event)"
      v-bind="{
        resultCount,
        unitLabels: {
          singular: unitLabels.singular.toLowerCase(),
          plural: unitLabels.plural.toLowerCase(),
        }
      }"
    />
    <Expand media="(max-width: 959px)">
      <span slot='header'>Filter {{ unitLabels.plural }}</span>
      <div class='directory__filters-list'>
        <slot name='filters' />
      </div>
    </Expand>

    <div class='directory__results-meta'>
      <span
        class='directory__result-count'
        :class="{'directory__result-count--is-loading': isLoading}"
      >{{ resultCountLabel }}</span>

      <button
        v-if="activeFilters.length"
        class="directory__clear-button"
        type="button"
        @click="$emit('clear-all')"
      >Clear all</button>

      <div class='directory__filter-tags' v-if="activeFilters.length">
        <CmTag
          v-for='filter in activeFilters'
          :key='filter.keys[0]'
          class='directory__filter-tag'
          :label="filter.label"
          :value="filter.label"
          @delete='$emit("clear-filter", filter.keys, filter.match)'
        />
      </div>
    </div>

    <div
      class='directory__list'
      :class="{
        'directory__list--is-loading': isLoading,
      }"
    >
      <slot />
    </div>

    <button
      v-if="results.length < resultCount"
      class="directory__load-button cm-button wide"
      type="button"
      @click="$emit('more-click')"
    >More</button>
  </div>
</template>

<script>
import { formatNumber } from "../lib/number";

import GuildSearch from "../components/guild-search";
import CmTag from "../components/tag";
import Expand from "../components/expand";

export default {
  components: {
    GuildSearch,
    CmTag,
    Expand
  },

  props: {
    results: {
      type: Array
    },
    inputText: {
      type: String
    },
    activeFilters: {
      type: Array
    },
    isLoading: {
      type: Boolean
    },
    filters: {
      type: Array
    },
    resultCount: {
      type: Number
    },
    unitLabels: {
      type: Object
    }
  },

  data() {
    return {};
  },

  computed: {
    hasInput() {
      return this.activeFilters.length || this.inputText !== "";
    },

    resultCountLabel() {
      if (this.isInitialLoad) return "Loading...";

      return [
        !this.hasInput && "Searching",
        formatNumber(this.resultCount),
        this.hasInput && "Matching",
        this.resultCount === 1
          ? this.unitLabels.singular
          : this.unitLabels.plural
      ]
        .filter(Boolean)
        .join(" ");
    }
  }
};
</script>

<style lang="scss" scoped>
.directory {
  position: relative;
  margin-bottom: 2rem;

  &:first-child {
    margin: 1rem 0 0;
  }

  &__input {
    margin-bottom: 1rem;
  }

  &__filters-list {
    margin: 0 0 1rem;
  }

  &__results-meta {
    display: grid;
    grid-gap: 1rem;
    padding: 0.5rem 0;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    border-top: 1px solid var(--bg-2);
    border-bottom: 1px solid var(--bg-2);
    overflow-x: auto;
    white-space: nowrap;
  }
  &__result-count {
    @extend %b1e;
    transition: opacity 0.3s ease;
    grid-column: 1 / 2;

    &--is-loading {
      opacity: 0.6;
    }
  }
  &__clear-button {
    @extend %b1e;
    grid-column: 3 / 4;
    background: none;
    border: none;
    display: flex;
    align-items: center;

    &::before {
      content: "close";
      appearance: none;
      background: none;
      border: none;
      font-size: 0.5rem;
      font-family: $ff_icon;
      font-weight: 400;
      margin-right: 5px;
    }
  }
  &__filter-tags {
    min-height: 2.5rem;
    display: flex;
    flex-flow: row wrap;
    grid-column: 1 / 4;
    @media (min-width: $bp_large) {
      grid-column: 2 / 3;
      grid-row: 1 / 2;
    }
  }
  &__filter-tag {
    margin: 0.25rem 0.2rem;
  }

  &__list {
    position: relative;
    transition: opacity 0.3s ease;
    min-height: 12rem;
    &--is-loading {
      opacity: 0.6;
      &::before {
        @include loading_before;
      }
    }
  }

  &__loading-indicator {
    position: absolute;
  }

  &__load-button {
    display: block;
    margin: 2rem auto 0;
  }
}
</style>



// WEBPACK FOOTER //
// app/javascript/components/directory.vue?ac733da6